import React, { ReactNode } from "react";

type CardProps = {
  children: ReactNode;
  className?: string;
  title?: string;
  subtitle?: string;
  childrenClass?: string;
  titleClass?: string;
  subtitleClass?: string;
}

const Card: React.FC<CardProps> = ({
  children,
  title,
  subtitle,
  className,
  childrenClass,
  titleClass,
  subtitleClass,
}) => {
  return (
    <div
      className={`h-full w-full outline-0 rounded-lg flex-col p-3 shadow-card bg-white flex justify-start ${className}`}
    >
      {(title || subtitle) && (
        <div
          className={`w-full pb-2 leading-4 tracking-wide text-brand font-semibold ${titleClass ?? ""}`}
        >
          {title}
          {subtitle && (
            <div
              className={`w-full leading-5 text-text-muted font-normal overflow-hidden ${subtitleClass ?? ""}`}
            >
              {subtitle}
            </div>
          )}
        </div>
      )}
      <div className={childrenClass}>{children}</div>
    </div>
  );
};

// Keep backward compat export
export { Card };
export default Card;
